// extracted by mini-css-extract-plugin
module.exports = {"dividerWrapper":"Divider_dividerWrapper__NGc9y","divider":"Divider_divider__2ld8w"};